/**
 * Ad Configuration
 * Centralized configuration for ad providers and placements
 */

export const AdProvider = {
  GOOGLE_ADSENSE: 'google-adsense',
  CUSTOM: 'custom',
  NONE: 'none',
};

export const AdFormat = {
  DISPLAY: 'display',
  IN_FEED: 'in-feed',
  IN_ARTICLE: 'in-article',
  MULTIPLEX: 'multiplex',
};

export const AdSize = {
  RESPONSIVE: 'responsive',
  RECTANGLE: '300x250',
  LEADERBOARD: '728x90',
  MOBILE_BANNER: '320x50',
  LARGE_RECTANGLE: '336x280',
};

export const adConfig = {
  // Set to false to disable all ads globally
  enabled: process.env.REACT_APP_ADS_ENABLED === 'true' || false,

  // Current provider
  provider: AdProvider.GOOGLE_ADSENSE,

  // Google AdSense configuration
  googleAdSense: {
    client: process.env.REACT_APP_ADSENSE_CLIENT || 'ca-pub-XXXXXXXXXXXXXXXX',
    testMode: process.env.NODE_ENV !== 'production',
  },

  // Ad placements configuration
  placements: {
    weatherInfoTop: {
      id: 'weather-info-top',
      enabled: true,
      format: AdFormat.DISPLAY,
      size: AdSize.RESPONSIVE,
      slot: process.env.REACT_APP_ADSENSE_SLOT_WEATHER_TOP || '1234567890',
    },
    weatherInfoBottom: {
      id: 'weather-info-bottom',
      enabled: true,
      format: AdFormat.DISPLAY,
      size: AdSize.RESPONSIVE,
      slot: process.env.REACT_APP_ADSENSE_SLOT_WEATHER_BOTTOM || '0987654321',
    },
    betweenCards: {
      id: 'between-weather-cards',
      enabled: true,
      format: AdFormat.IN_FEED,
      size: AdSize.RESPONSIVE,
      slot: process.env.REACT_APP_ADSENSE_SLOT_IN_FEED || '1122334455',
    },
    sidebar: {
      id: 'sidebar-ad',
      enabled: false, // Disabled by default
      format: AdFormat.DISPLAY,
      size: AdSize.RECTANGLE,
      slot: process.env.REACT_APP_ADSENSE_SLOT_SIDEBAR || '5544332211',
    },
  },

  // Delay before showing ads (in ms) to improve UX
  displayDelay: 500,

  // Refresh interval for ads (optional, in ms) - set to 0 to disable
  refreshInterval: 0,
};

export default adConfig;
